import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import LogInButton from 'flarum/forum/components/LogInButton';
import WelcomeHero from 'flarum/forum/components/WelcomeHero';
// Both modals are lazy loaded in 2.x.
const signUp = () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'));
const logIn = () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));

/**
 * fof/oauth sends guests the providers an admin has turned on, so the button is left out until Disqus is configured.
 */
function disqusEnabled() {
  return !!app.forum.attribute('fof-oauth')?.some(provider => provider?.name === 'disqus');
}

/**
 * Adds "Continue with Disqus" and "Sign Up Now" buttons, plus a log in link, to the welcome hero for guests.
 */
export default function extendWelcomeHero() {
  extend(WelcomeHero.prototype, 'contentItems', function (items) {
    if (app.session.user) return;
    const showDisqus = disqusEnabled();
    // fof/oauth's OAuth-only mode rejects password sign-ups and hides core's Sign Up link, so this follows suit.
    const showSignUp = !!app.forum.attribute('allowSignUp') && !app.forum.attribute('fofOauthOnly');
    items.add('auth', m("div", {
      className: "WelcomeHero-auth"
    }, (showDisqus || showSignUp) && m("div", {
      className: "WelcomeHero-authButtons"
    }, showDisqus && m(LogInButton, {
      className: "Button LogInButton--disqus",
      icon: "fab fa-disqus",
      path: "/auth/disqus"
    }, app.translator.trans('batmannews-oauth-disqus.forum.welcome_hero.disqus_button')), showDisqus && showSignUp && m("span", {
      className: "WelcomeHero-authOr"
    }, app.translator.trans('batmannews-oauth-disqus.forum.welcome_hero.or_text')), showSignUp && m(Button, {
      className: "Button Button--primary WelcomeHero-signUp",
      onclick: signUp
    }, app.translator.trans('batmannews-oauth-disqus.forum.welcome_hero.sign_up_button'))), m("p", {
      className: "WelcomeHero-logIn"
    }, app.translator.trans('batmannews-oauth-disqus.forum.welcome_hero.log_in_text', {
      a: m(Button, {
        className: "Button Button--text Button--link",
        onclick: logIn
      })
    }))), -10);
  });
}